import React from 'react';
import { observer } from 'mobx-react-lite';
import { popupStore } from '../../store/popupStore';
import { Popup } from '../../components';

const PopupWrapper = observer(() => {
  const { isOpenPopup } = popupStore;
  if (!isOpenPopup) {
    return null;
  }
  return <Popup />;
});
export default PopupWrapper;
